import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const SubmitSurvey = gql`
  mutation SubmitSurvey($input: SubmitSurveyInput!) {
    submitSurvey(input: $input) {
      __typename
      ... on SubmitSurveySuccess {
        __typename
        success
      }
      ... on SubmitSurveyError {
        __typename
        ...error
      }
    }
  }
  ${error}
`;

export default SubmitSurvey;
